import PostableEditor from "./PostableEditor";

export default PostableEditor;